<div
  id="uzd-organiv-malogo-tazu"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12 clr-col-md-6">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="omt_date" />
      </div>
      <div class="clr-col-sm-12 clr-col-md-6">
        <clr-select-container [class.clr-float-md-right]="true">
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="omt_type">
            <option value="трансабдомінально">трансабдомінально</option>
            <option value="трансвагінально">трансвагінально</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">День менструального циклу</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput formControlName="omt_menstrual" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="omt_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('дворога', 'omt_matka')"> дворога </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('сідловидна', 'omt_matka')">сідловидна</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Матка</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_matka"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Положення:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="omt_polozennya">
            <option value="anteflexio">Anteflexio</option>
            <option value="retroflexio">Retroflexio</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-2">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Розміри тіла матки:</label>
        </clr-input-container>
      </div>

      <div class="clr-col-sm-2 width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">довжина:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="omt_dovzyna" />
        </clr-input-container> мм,
      </div>

      <div class="clr-col-sm-2 width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">товщина:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="omt_tovshuna" />
        </clr-input-container> мм,
      </div>

      <div class="clr-col-sm-2 width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ширина:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="omt_shuruna" />
        </clr-input-container> мм.
      </div>

      <div class="clr-col-sm-2 width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">V = </label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="omt_v" />
        </clr-input-container> см <span class="step">3</span>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('однорідна', 'omt_exostructure')"> однорідна </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('неоднорідна', 'omt_exostructure')">неоднорідна</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('за рахунок вогнищ ендометріозу.', 'omt_exostructure')">за рахунок вогнищ ендометріозу.</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('за рахунок фіброматозних вузлів.', 'omt_exostructure')">за рахунок фіброматозних вузлів.</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('за рахунок варикозно розширених вен.', 'omt_exostructure')">за рахунок варикозно розширених вен.</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('за рахунок вогнищ аденоміозу.', 'omt_exostructure')">за рахунок вогнищ аденоміозу.</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ехоструктура</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_exostructure"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('інтрамуральний ф/в  х  мм, V=  см3.', 'omt_perednya_stinka')"> інтрамуральний ф/в </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('субсерозний ф/в  х  мм, V=  см3.', 'omt_perednya_stinka')"> субсерозний ф/в  </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('інтрамурально-субсерозний ф/в  х  мм, V=  см3.', 'omt_perednya_stinka')"> інтрамурально-субсерозний ф/в </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('субмукозний вузол х  мм, V=  см3.', 'omt_perednya_stinka')"> субмукозний вузол </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ПЕРЕДНЯ СТІНКА</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_perednya_stinka"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('інтрамуральний ф/в  х  мм, V=  см3.', 'omt_zadnya_stinka')"> інтрамуральний ф/в </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('субсерозний ф/в  х  мм, V=  см3.', 'omt_zadnya_stinka')"> субсерозний ф/в  </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('інтрамурально-субсерозний ф/в  х  мм, V=  см3.', 'omt_zadnya_stinka')"> інтрамурально-субсерозний ф/в </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('субмукозний вузол х  мм, V=  см3.', 'omt_zadnya_stinka')"> субмукозний вузол </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЗАДНЯ СТІНКА</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_zadnya_stinka"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('інтрамуральний ф/в  х  мм, V=  см3.', 'omt_dno')"> інтрамуральний ф/в </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('субсерозний ф/в  х  мм, V=  см3.', 'omt_dno')"> субсерозний ф/в  </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('інтрамурально-субсерозний ф/в  х  мм, V=  см3.', 'omt_dno')"> інтрамурально-субсерозний ф/в </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('субмукозний вузол х  мм, V=  см3.', 'omt_dno')"> субмукозний вузол </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ДНО</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_dno"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('однорідний', 'omt_endometrii')"> однорідний </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('неоднорідний', 'omt_endometrii')"> неоднорідний </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ендометрій</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_endometrii"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('деформована', 'omt_poroznyna')"> деформована </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('не деформована', 'omt_poroznyna')"> не деформована </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('поширена', 'omt_poroznyna')"> поширена </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ВМС розташована правильно', 'omt_poroznyna')"> ВМС розташована правильно </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Порожнина матки</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_poroznyna"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">шийка матки</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="omt_shuyka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('без особливостей', 'omt_tservikalnyy_kanal')"> без особливостей </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('поширений до   мм', 'omt_tservikalnyy_kanal')"> поширений до   мм </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Цервікальний канал</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_tservikalnyy_kanal"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">правий ЯЄЧНИК</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="omt_right_yayechnyk" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('типово', 'omt_right_rozstashuvannya')"> типово </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('по ребру', 'omt_right_rozstashuvannya')"> по ребру </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('біля кута', 'omt_right_rozstashuvannya')"> біля кута </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Розташування</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_right_rozstashuvannya"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Розміром:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="omt_rigth_rozmir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('дрібні фолікули.', 'omt_rigth_v_structuri')"> дрібні фолікули. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('множинні атретичні фолікули.', 'omt_rigth_v_structuri')">множинні атретичні фолікули. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('анехогенний утвір d  мм, V=  см3.', 'omt_rigth_v_structuri')"> анехогенний утвір d  мм, V=  см3. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('гіпоехогенний утвір d  мм, V=  см3.', 'omt_rigth_v_structuri')"> гіпоехогенний утвір d  мм, V=  см3. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('гіперехогенний утвір d  мм, V=  см3.', 'omt_rigth_v_structuri')"> гіперехогенний утвір d  мм, V=  см3. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('гетерогенний утвір d  мм, V=  см3.', 'omt_rigth_v_structuri')"> гетерогенний утвір d  мм, V=  см3. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('фолікул d=', 'omt_rigth_v_structuri')"> фолікул d= </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('жовте тіло', 'omt_rigth_v_structuri')"> жовте тіло </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">в структурі яйника</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_rigth_v_structuri"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('не поширена', 'omt_right_truba')"> не поширена </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('поширена до   мм.', 'omt_right_truba')"> поширена до   мм. </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Права маткова труба:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_right_truba"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Лівий ЯЄЧНИК</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="omt_left_yayechnyk" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('типово', 'omt_left_rozstashuvannya')"> типово </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('по ребру', 'omt_left_rozstashuvannya')"> по ребру </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('біля кута', 'omt_left_rozstashuvannya')"> біля кута </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Розташування</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_left_rozstashuvannya"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Розміром:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="omt_left_rozmir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('дрібні фолікули.', 'omt_left_v_structuri')"> дрібні фолікули. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('множинні атретичні фолікули.', 'omt_left_v_structuri')">множинні атретичні фолікули. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('анехогенний утвір d  мм, V=  см3.', 'omt_left_v_structuri')"> анехогенний утвір d  мм, V=  см3. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('гіпоехогенний утвір d  мм, V=  см3.', 'omt_left_v_structuri')"> гіпоехогенний утвір d  мм, V=  см3. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('гіперехогенний утвір d  мм, V=  см3.', 'omt_left_v_structuri')"> гіперехогенний утвір d  мм, V=  см3. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('гетерогенний утвір d  мм, V=  см3.', 'omt_left_v_structuri')"> гетерогенний утвір d  мм, V=  см3. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('фолікул d=', 'omt_left_v_structuri')"> фолікул d= </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('жовте тіло', 'omt_left_v_structuri')"> жовте тіло </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">в структурі яйника</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_left_v_structuri"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('не поширена', 'omt_left_truba')"> не поширена </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('поширена до   мм.', 'omt_left_truba')"> поширена до   мм. </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ліва маткова труба:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_left_truba"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('немає', 'omt_riduna_v_duglas')"> немає </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' x мм, V= см3', 'omt_riduna_v_duglas')"> є </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Рідина в дугласовому просторі:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_riduna_v_duglas"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('Патології на момент огляду не виявлено.', 'omt_zakluchennya')"> Патології на момент огляду не виявлено. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Патологія шийки матки.', 'omt_zakluchennya')"> Патологія шийки матки. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Вузловата міома тіла матки.', 'omt_zakluchennya')">Вузловата міома тіла матки. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Фіброміома тіла матки.', 'omt_zakluchennya')">Фіброміома тіла матки. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Контроль СБ через 10 днів.', 'omt_zakluchennya')">Контроль СБ через 10 днів. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Ендометріоз тіла матки.', 'omt_zakluchennya')">Ендометріоз тіла матки. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Патологія ендеметрію.', 'omt_zakluchennya')">Патологія ендеметрію. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Тенденція до полікистозної будови яйників.', 'omt_zakluchennya')">Тенденція до полікистозної будови яйників. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Адгезивний процес.', 'omt_zakluchennya')">Адгезивний процес. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Персистенція фолікула.', 'omt_zakluchennya')">Персистенція фолікула. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Фіброміома тіла матки в поєднанні з аделоміозом / ендоментріозом.', 'omt_zakluchennya')">Фіброміома тіла матки в поєднанні з аделоміозом / ендоментріозом. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Параоваріальна киста зліва / справа.', 'omt_zakluchennya')">Параоваріальна киста зліва / справа. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Киста правого / лівого яйника (ендометріоїдна / жовтого тіла / ретенційна).', 'omt_zakluchennya')">Киста правого / лівого яйника (ендометріоїдна / жовтого тіла / ретенційна). </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ВМС.', 'omt_zakluchennya')">ВМС. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Патологія цервікального каналу (поліп).', 'omt_zakluchennya')">Патологія цервікального каналу (поліп). </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Персистенція фолікула / жовтого тіла зліва / справа.', 'omt_zakluchennya')">Персистенція фолікула / жовтого тіла зліва / справа. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Аденоміоз тіла матки.', 'omt_zakluchennya')">Аденоміоз тіла матки. </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЗАКЛЮЧЕННЯ:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_zakluchennya"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('Контроль в динаміці.', 'omt_rekomendatsii')"> Контроль в динаміці. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Контроль ендометрію на 4-5-й день циклу.', 'omt_rekomendatsii')"> Контроль ендометрію на 4-5-й день циклу. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('І УЗС в 12 тижнів.', 'omt_rekomendatsii')"> І УЗС в 12 тижнів. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('Контроль СБ через 10 днів.', 'omt_rekomendatsii')"> Контроль СБ через 10 днів. </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">РЕКОМЕНДОВАНО:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="omt_rekomendatsii"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>

  </form>

</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
